export enum StatusTicketEnum {
    DEFAULT = 'Default',
    CREATED = 'Created',
    CLOSED = 'Closed',
    CANCEL = 'Cancelled',
}
